/**
 * Eventos de analítica del registro de anunciantes.
 *
 * Empuja al `dataLayer` de Google Tag Manager si existe en la página; si no,
 * no hace nada. Así los eventos quedan instrumentados sin añadir ninguna
 * dependencia ni recurso externo, y sin romper nada si nunca se instala GTM.
 *
 * NUNCA se registran contraseñas, tokens, el contenido del RUT ni datos
 * personales innecesarios: solo el nombre del evento y metadatos no sensibles.
 */
export const EVENTOS = {
    VER: 'register_view',
    CLIC_GOOGLE: 'register_google_click',
    CLIC_CORREO: 'register_email_click',
    PASO_1: 'register_step_1_complete',
    PASO_2: 'register_step_2_complete',
    PASO_3: 'register_step_3_complete',
    ENVIAR: 'register_submit',
    EXITO: 'register_success',
    FALLO: 'register_failed',
    RUT: 'rut_upload',
    TERMINOS: 'terms_accept',
    LOGIN_DESDE_REGISTRO: 'login_from_register'
};

/** Claves que jamás deben salir en un evento. */
const PROHIBIDAS = [
    'password',
    'password_confirmation',
    'token',
    'access_token',
    'id_token',
    'google_token',
    'rut',
    'documento',
    'nit',
    'celular',
    'email'
];

function limpiar(datos) {
    if (!datos || typeof datos !== 'object') return {};

    const salida = {};

    Object.keys(datos).forEach((clave) => {
        const minus = String(clave).toLowerCase();
        const prohibida = PROHIBIDAS.some((p) => minus.indexOf(p) !== -1);
        if (!prohibida) {
            salida[clave] = datos[clave];
        }
    });

    return salida;
}

export function registrarEvento(evento, datos) {
    if (!evento || typeof window === 'undefined') return;

    if (!Array.isArray(window.dataLayer)) return;

    window.dataLayer.push(Object.assign({ event: evento }, limpiar(datos)));
}
